// Sonner laddas först när en toast faktiskt visas (2026-10-17, prestanda på annonslandningar).
//
// `import { toast } from 'sonner'` i köpknappen, jämför-/önskelistknapparna, produktkorten
// och fordonspanelen drog in hela sonner (~10 kB komprimerat) i de skript som hämtas innan
// produktbilden målas — PageSpeed räknar alla sådana byte in i LCP. Toastern själv är redan
// lat (providers.tsx), och Header gör samma sak för utloggningen. Samma modulinstans som
// Toastern använder, så beteendet är oförändrat; första toasten kommer bara några ms senare.
type Sonner = typeof import('sonner');
type ToastFn = Sonner['toast'];
type Kind = 'success' | 'error' | 'info' | 'warning';

function visa(kind: Kind | null, args: Parameters<ToastFn>) {
  import('sonner')
    .then(({ toast }) => (kind ? toast[kind](...args) : toast(...args)))
    .catch(() => {});
}

export const toast = Object.assign(
  (...args: Parameters<ToastFn>) => visa(null, args),
  {
    success: (...args: Parameters<ToastFn>) => visa('success', args),
    error: (...args: Parameters<ToastFn>) => visa('error', args),
    info: (...args: Parameters<ToastFn>) => visa('info', args),
    warning: (...args: Parameters<ToastFn>) => visa('warning', args),
  },
);
